import { render, staticRenderFns } from "./commodity-box.vue?vue&type=template&id=0964d9e0&"
import script from "./commodity-box.vue?vue&type=script&lang=js&"
export * from "./commodity-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports